// react-icons
import { IoIosArrowDown } from 'react-icons/io'
import FooterItem from './footer/FooterItem';

function Footer() {
    return (
        <div className='FooterBg'>
            <div className='Footer'>
                <div className='Footer-Row1'>
                    <div>Language</div>
                    <button>English<IoIosArrowDown/></button>
                </div>
                <div className='Footer-Row2'>
                    <FooterItem
                        menu={{
                            name: "Pricing",
                            link: "/pricing"
                        }}
                        subMenuList={[
                            {
                                name: "Basic",
                                link: "/pricing"
                            },
                            {
                                name: "Pro",
                                link: "/pricing"
                            },
                            {
                                name: "Business",
                                link: "/pricing"
                            },
                        ]}
                    />
                    <FooterItem
                        menu={{
                            name: "Resources",
                            link: "/resources"
                        }}
                        subMenuList={[
                            {
                                name: "Blog",
                                link: "/resources/blog"
                            },
                            {
                                name: "Linked In",
                                link: "/resources/linked-in"
                            },
                            {
                                name: "Help Center",
                                link: "/resources/help-center"
                            },
                            {
                                name: "Partner",
                                link: "/resources/partner"
                            }
                        ]}
                    />
                </div>
                <div className='Footer-Row3'>Copyright - GLMP by 2023</div>  
            </div>
        </div>
    );
}

export default Footer;